import i18n from "../../i18n";
import {
  AUTOCOMPLETE_FIELD_TYPE,
  DATE_RANGE_FIELD_TYPE,
  NUMERIC_FIELD_TYPE,
  NUMERIC_RANGE_FIELD_TYPE,
  TEXT_FIELD_TYPE,
} from "../../helpers/constants";
import DateService from "../../services/dateService";
import SendIcon from '@mui/icons-material/Send';
import ModeEditOutlineOutlined from "@mui/icons-material/ModeEditOutlineOutlined";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export const SURVEY_TABLE_NAME = "survey_registry";

export const SURVEY_TABLE_FIELDS_CONFIG = [

  {
    name: "hrsurvey_date_send",
    label: i18n.t("table.survey_registry_table.hrsurvey_date_send"),
    getValueCallback: (rowData,  onClickSendSurvey) => {
      const content = (
        <SendIcon onClick={(e) => onClickSendSurvey(e, rowData.id, rowData.allow_send_survey)} />
      );
      return rowData.show_send_button  ? content : DateService.convertDateToFormatYYYYMMDD(rowData.hrsurvey_date_send);
    },
    filterType: DATE_RANGE_FIELD_TYPE,
    allowChangeVisibility: false,
    excludedFromExport: true,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "hrsurvey_name",
    getValueCallback: (rowData) => rowData.hrsurvey_name,
    label: i18n.t("table.survey_registry_table.hrsurvey_name"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "organizer",
    getValueCallback: (rowData) => rowData.organizer,
    label: i18n.t("table.survey_registry_table.organizer"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData?.value?.users,
      isObjectOption: true,
      addNewValue: false,
      multiple: true,
      optionLabelKey: "full_name"
    }),
  },
  {
    name: "evaluated",
    getValueCallback: (rowData) => rowData.evaluated,
    label: i18n.t("table.survey_registry_table.evaluated"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData?.value?.users,
      isObjectOption: true,
      addNewValue: false,
      multiple: true,
      optionLabelKey: "full_name"
    }),
  },
  {
    name: "evaluators",
    getValueCallback: (rowData) => rowData.evaluators,
    label: i18n.t("table.survey_registry_table.evaluators"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData?.value?.users,
      isObjectOption: true,
      addNewValue: false,
      multiple: true,
      optionLabelKey: "full_name"
    }),
  },
  {
    name: "hrsurvey_goal",
    getValueCallback: (rowData) => rowData.hrsurvey_goal,
    label: i18n.t("table.survey_registry_table.hrsurvey_goal"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "hrsurvey_invitation",
    getValueCallback: (rowData) => rowData.hrsurvey_invitation,
    label: i18n.t("table.survey_registry_table.hrsurvey_invitation"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "hrsurvey_date_expired",
    getValueCallback: (rowData) =>
      DateService.convertDateToFormatYYYYMMDD(rowData.hrsurvey_date_expired),
    label: i18n.t("table.survey_registry_table.hrsurvey_date_expired"),
    filterType: DATE_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      style: { minWidth: "100px" },
    }),
    sortable: true,
  },
  {
    name: "hrsurvey_date_close",
    getValueCallback: (rowData) =>
      DateService.convertDateToFormatYYYYMMDD(rowData.hrsurvey_date_close),
    label: i18n.t("table.survey_registry_table.hrsurvey_date_close"),
    filterType: DATE_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      style: { minWidth: "100px" },
    }),
    sortable: true,
  },
  {
    name: "edit",
    getValueCallback: (rowData, onClickSendSurvey, onClickOpenSurvey, onClickCopySurvey) => (
      <ModeEditOutlineOutlined onClick={(e) => onClickOpenSurvey(e, rowData.id)} />
    ),
    label: i18n.t("table.survey_registry_table.edit"),
    filterType: null,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    excludedFromExport: true,
    allowChangeVisibility: false,
  },
  {
    name: "copy",
    getValueCallback: (rowData, onClickSendSurvey, onClickOpenSurvey, onClickCopySurvey) => (
      <ContentCopyIcon onClick={(e) => onClickCopySurvey(e, rowData.id)} />
    ),
    label: i18n.t("table.survey_registry_table.copy"),
    filterType: null,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    excludedFromExport: true,
    allowChangeVisibility: false,
  }
];
